import clsx from 'clsx';

import Button from 'components/Button';
import { FixedImage } from 'components/NextImage';
import Rating from 'components/Rating';
import TruncatedText from 'components/TruncatedText';
import { useEventContext } from 'context/EventContext';

import classes from './Alternative.module.scss';

const Alternative = ({ listing }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'product_card-alternative',
  });

  return (
    <div
      data-testid="listing-item_alternative"
      className={clsx('ListingAlternative', classes.root)}
    >
      <div className={classes.container}>
        <a
          className={classes.logoLink}
          href={listing.cta_urls.detail}
          aria-label={`${listing.name} details`}
          {...addEvent({
            engagementDetails: 'logo_product',
            engagementDestination: 'go-to_product_details',
            name: 'engagement_product_click',
          })}
        >
          <span className={classes.logoContainer}>
            <FixedImage
              className={classes.logo}
              width={52}
              src={listing.logo_url}
              alt={listing.logo_url ? `${listing.name} logo` : ''}
            />
          </span>
        </a>
        <div className={classes.headlineContainer}>
          <a
            className={classes.link}
            href={listing.cta_urls.detail}
            {...addEvent({
              engagementDetails: 'text-link_product-name',
              engagementDestination: 'go-to_product_details',
              name: 'engagement_product_click',
            })}
          >
            {listing.name}
          </a>
          <Rating.Link
            href={listing.cta_urls.reviews}
            average={listing.rating_avg}
            totals={listing.num_reviews}
          />
        </div>
      </div>
      <TruncatedText
        className={classes.description}
        text={listing.description}
        hideLabel={true}
        variant="tight-xs"
      />
      <Button
        className={classes.button}
        color="primary"
        fullWidth={true}
        variant="text"
        {...addEvent({
          engagementDetails: 'button_learn-more',
          engagementDestination: 'go-to_product_details',
          name: 'engagement_product_click',
        })}
        href={listing.cta_urls.detail}
      >
        Learn More
      </Button>
    </div>
  );
};

export default Alternative;
